"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "showMenu"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Activity/components/StateNav.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "nav-header position-relative border-bottom",
        style: "height:15rem"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("01480b"),
    marko_node0 = marko_createElement("div", {
        "class": "position-absolute w-100 bottom-0 px-3 py-3"
      }, "8", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "d-flex justify-content-between"
        }, null, null, 4)
        .e("div", null, null, null, 2)
          .e("h5", null, null, null, 1)
            .t("5")
          .e("span", null, null, null, 1)
            .t("Modules")
        .e("div", null, null, null, 2)
          .e("h5", null, null, null, 1)
            .t("23")
          .e("span", null, null, null, 1)
            .t("Lessons")
        .e("div", null, null, null, 2)
          .e("h5", null, null, null, 1)
            .t("4")
          .e("span", null, null, null, 1)
            .t("Tests")
        .e("div", null, null, null, 2)
          .e("h5", null, null, null, 1)
            .t("2")
          .e("span", null, null, null, 1)
            .t("Hours"),
    marko_attrs1 = {
        "class": "cursor-pointer",
        title: "Close Navigation"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 px-3 py-1 d-flex align-items-center",
      col: [
          {
              class: "col p-0",
              renderBody: function(out) {
                out.be("span", {
                    "class": "cursor-pointer",
                    title: (state.showMenu != true ? "Show" : "Hide") + " Menu"
                  }, "3", component, null, 0, {
                    onclick: __component.d("click", () => GState.menu.show(), false)
                  });

                Bx_tag({
                    type: "menu-alt-" + (state.showMenu != true ? "left" : "right"),
                    class: "font-large-2"
                  }, out, __component, "4");

                out.ee();
              }
            },
          {
              class: "col p-0 text-right",
              renderBody: function(out) {
                out.be("span", marko_attrs1, "6", component, null, 0, {
                    onclick: __component.d("click", () => component.emit('close'), false)
                  });

                Bx_tag({
                    type: "chevron-left",
                    class: "font-medium-5 border rounded-circle theme-bg p-50"
                  }, out, __component, "7");

                out.ee();
              }
            }
        ]
    }, out, __component, "1");

  out.n(marko_node0, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
